angular
	.module('inputPin.components', [])
	.component('inputPin', {
		templateUrl: 'ng/components/inputPin/inputPin.html',
		bindings: {
			/** Input data **/
			inputId: '@',
			inputName: '@',
			inputClass: '@',
			inputPlaceholder: '@',
			formName: '=',
			bindingVariable: '=',
			/** Optional data **/
			hasError: '<',
			inputDisableOn: '<'
		},
		controllerAs: 'inputPinCtrl',
		controller: function ($scope, $translate, validationService, $uniService) {

			/** not to loose *this reference **/
			var self = this;

			self.validationService = validationService;
			self.uniService = $uniService;

			self.$onInit = function () {
				console.log(self);
				self.inputDisableOn = self.inputDisableOn || false;
			}

			self.$onChanges = function (values) {
				if (self.bindingVariable) {
					if (self.hasError) {
						self.formName.$invalid = true;
						self.formName.$valid = false;
						self.formName[self.inputName].$setValidity('equal', false);
					} else {
						self.formName.$invalid = false;
						self.formName.$valid = true;
						self.formName[self.inputName].$setValidity('equal', true);
					}
				}

			}


		}
	});